// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Cairo/static/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Cairo/static/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Manrope:wght@200;300;400;500;600;700;800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*** Common variables ***/
@font-face {
  font-family: "Cairo";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  /* Add additional font weights and styles here if needed */
}
:root {
  --blue-color: #0c356a;
  --green-color: #4ce13f;
  --yellow-color: #ffc436;
  --red-color: #ef0606;
  --dark-color: #292929;
  --light-color: #0174be;
  --font-family-lato: "Lato", sans-serif;
  --font-family-manrope: "Manrope", sans-serif;
  --font-size: 16px;
  --line-height: 1.6;
  --font-weight: 400;
  --default-transition: all 300ms ease-in-out;
  --chart-primary-color: #475be8;
  --chart-secondary-color: #e6e6e6;
  --light-shadow1: rgba(0, 0, 0, 0.02) 0px 4px 12px;
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  font-family: inherit;
}

body {
  font-family: var(--font-family-lato);
  font-size: var(--font-size);
  font-weight: var(--font-weight);
  background-color: #f8f8f8;
  --primary-color: #475be8;
  --secondary-color: #fff;
  --background-color: #fafafa;
  --side-link-hover-color: #f6f6f6;
  --side-text-color: #808191;
  --logo-color: var(--primary-color);
  --xl-text-color: #292929;
  --lg-text-color: #525252;
  --base-text-color: #676767;
  --text-color-inverted: #292929;
  --bg-color-inverted: #ffffff;
  --border-color-inverted: #f6f6f6;
  --toggle-btn-border-color: #f3f3f3;
  --toggle-btn-bg-color: #fff;
  --toggle-btn-icon-color: var(--primary-color);
  --thead-bg-color: #f2f4ff;
  --tbl-border-color: #f2f4ff;
  --scroll-track-bg-color: #fff;
  --scroll-thumb-bg-color: #e9e9e9;
}
body.dark-mode {
  --primary-color: #475be8;
  --secondary-color: #2e2e48;
  --background-color: #383854;
  --side-link-hover-color: #525270;
  --side-text-color: #e1e1e1;
  --logo-color: #fff;
  --xl-text-color: #ffff;
  --lg-text-color: #f3f3f3;
  --base-text-color: #e0e0e0;
  --text-color-inverted: #fff;
  --bg-color-inverted: #292929;
  --border-color-inverted: #575777;
  --toggle-btn-border-color: #525270;
  --toggle-btn-bg-color: #525270;
  --toggle-btn-icon-color: #bdbdbd;
  --thead-bg-color: #383854;
  --tbl-border-color: ##383854;
  --scroll-track-bg-color: #2e2e48;
  --scroll-thumb-bg-color: #575777;
}

a {
  text-decoration: none;
}

button {
  background-color: transparent;
  border: none;
  outline: 0;
  cursor: pointer;
}

ul {
  list-style-type: none;
}

.theme-toggle-btn {
  background-color: var(--bg-color-inverted);
  position: fixed;
  right: 0;
  top: 20px;
  width: 48px;
  height: 40px;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: 0;
  z-index: 999;
  cursor: pointer;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.theme-toggle-btn .theme-icon {
  width: 24px;
}

.page-wrapper {
  background-color: var(--background-color);
  min-height: 100vh;
  overflow: hidden;
}

.content-wrapper {
  background-color: var(--background-color);
  min-height: 100vh;
  padding: 50px 58px;
  margin-left: 260px;
}
@media (max-width: 1400px) {
  .content-wrapper {
    padding: 32px;
  }
}
@media (max-width: 1200px) {
  .content-wrapper {
    margin-left: 56px;
  }
}
@media (max-width: 768px) {
  .content-wrapper {
    margin-left: 0;
    padding: 24px;
  }
}
@media (max-width: 576px) {
  .content-wrapper {
    margin-left: 0;
    padding: 16px;
  }
}

.content-area > section {
  margin-bottom: 16px;
}
.content-area > section:last-child {
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAGA,yBAAA;AAEA;EACE,oBAAA;EACA,+DAAA;EACA,+DAAA;EACA,0DAAA;AAFF;AAIA;EAEE,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;EAEA,sCAAA;EACA,4CAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EAEA,2CAAA;EAEA,8BAAA;EACA,gCAAA;EAEA,iDAAA;AAPF;;AAuDA;EACE,UAAA;EACA,SAAA;EACA,sBAAA;EACA,oBAAA;AApDF;;AAwDA;EACE,oCAAA;EACA,2BAAA;EACA,+BAAA;EACA,yBAAA;EAvDA,wBAAA;EACA,uBAAA;EACA,2BAAA;EACA,gCAAA;EACA,0BAAA;EACA,kCAAA;EACA,wBAAA;EACA,wBAAA;EACA,0BAAA;EACA,8BAAA;EACA,4BAAA;EACA,gCAAA;EACA,kCAAA;EACA,2BAAA;EACA,6CAAA;EACA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,gCAAA;AAGF;AAuCE;EAtCA,wBAAA;EACA,0BAAA;EACA,2BAAA;EACA,gCAAA;EACA,0BAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,gCAAA;EACA,kCAAA;EACA,8BAAA;EACA,gCAAA;EACA,yBAAA;EACA,4BAAA;EACA,gCAAA;EACA,gCAAA;AAEF;;AAuBA;EACE,qBAAA;AApBF;;AAuBA;EACE,6BAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AApBF;;AAuBA;EACE,qBAAA;AApBF;;AAwBA;EACE,0CAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,qDAAA;AArBF;AAuBE;EACE,WAAA;AArBJ;;AAyBA;EACE,yCAAA;EACA,iBAAA;EACA,gBAAA;AAtBF;;AAyBA;EACE,yCAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAtBF;AAwBE;EANF;IAOI,aAAA;EArBF;AACF;AAuBE;EAVF;IAWI,iBAAA;EApBF;AACF;AAsBE;EAdF;IAeI,cAAA;IACA,aAAA;EAnBF;AACF;AAqBE;EAnBF;IAoBI,cAAA;IACA,aAAA;EAlBF;AACF;;AAuBE;EACE,mBAAA;AApBJ;AAqBI;EACE,gBAAA;AAnBN","sourcesContent":["// google fonts\n@import url(\"https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Manrope:wght@200;300;400;500;600;700;800&display=swap\");\n\n/*** Common variables ***/\n\n@font-face {\n  font-family: \"Cairo\";\n  src: url(\"./fonts/Cairo/static/Cairo-Regular.ttf\") format(\"truetype\");\n  src: url(\"./fonts/Cairo/static/Cairo-Bold.ttf\") format(\"truetype\");\n  /* Add additional font weights and styles here if needed */\n}\n:root {\n  // colors\n  --blue-color: #0c356a;\n  --green-color: #4ce13f;\n  --yellow-color: #ffc436;\n  --red-color: #ef0606;\n  --dark-color: #292929;\n  --light-color: #0174be;\n  // typography\n  --font-family-lato: \"Lato\", sans-serif;\n  --font-family-manrope: \"Manrope\", sans-serif;\n  --font-size: 16px;\n  --line-height: 1.6;\n  --font-weight: 400;\n  // transition\n  --default-transition: all 300ms ease-in-out;\n  // chart\n  --chart-primary-color: #475be8;\n  --chart-secondary-color: #e6e6e6;\n  // box shadow\n  --light-shadow1: rgba(0, 0, 0, 0.02) 0px 4px 12px;\n}\n\n// color mode toggle mixins\n@mixin lightMode {\n  --primary-color: #475be8;\n  --secondary-color: #fff;\n  --background-color: #fafafa;\n  --side-link-hover-color: #f6f6f6;\n  --side-text-color: #808191;\n  --logo-color: var(--primary-color);\n  --xl-text-color: #292929;\n  --lg-text-color: #525252;\n  --base-text-color: #676767;\n  --text-color-inverted: #292929;\n  --bg-color-inverted: #ffffff;\n  --border-color-inverted: #f6f6f6;\n  --toggle-btn-border-color: #f3f3f3;\n  --toggle-btn-bg-color: #fff;\n  --toggle-btn-icon-color: var(--primary-color);\n  --thead-bg-color: #f2f4ff;\n  --tbl-border-color: #f2f4ff;\n  --scroll-track-bg-color: #fff;\n  --scroll-thumb-bg-color: #e9e9e9;\n}\n\n@mixin darkMode {\n  --primary-color: #475be8;\n  --secondary-color: #2e2e48;\n  --background-color: #383854;\n  --side-link-hover-color: #525270;\n  --side-text-color: #e1e1e1;\n  --logo-color: #fff;\n  --xl-text-color: #ffff;\n  --lg-text-color: #f3f3f3;\n  --base-text-color: #e0e0e0;\n  --text-color-inverted: #fff;\n  --bg-color-inverted: #292929;\n  --border-color-inverted: #575777;\n  --toggle-btn-border-color: #525270;\n  --toggle-btn-bg-color: #525270;\n  --toggle-btn-icon-color: #bdbdbd;\n  --thead-bg-color: #383854;\n  --tbl-border-color: ##383854;\n  --scroll-track-bg-color: #2e2e48;\n  --scroll-thumb-bg-color: #575777;\n}\n\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  font-family: inherit;\n}\n\n// color mode toggle in body\nbody {\n  font-family: var(--font-family-lato);\n  font-size: var(--font-size);\n  font-weight: var(--font-weight);\n  background-color: #f8f8f8;\n  // by default light mode is on\n  @include lightMode();\n\n  // add dark-mode class on the body if dark mode is set true\n  &.dark-mode {\n    @include darkMode();\n  }\n}\n\na {\n  text-decoration: none;\n}\n\nbutton {\n  background-color: transparent;\n  border: none;\n  outline: 0;\n  cursor: pointer;\n}\n\nul {\n  list-style-type: none;\n}\n\n// theme toggle button\n.theme-toggle-btn {\n  background-color: var(--bg-color-inverted);\n  position: fixed;\n  right: 0;\n  top: 20px;\n  width: 48px;\n  height: 40px;\n  border-top-left-radius: 30px;\n  border-bottom-left-radius: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  outline: 0;\n  z-index: 999;\n  cursor: pointer;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n\n  .theme-icon {\n    width: 24px;\n  }\n}\n\n.page-wrapper {\n  background-color: var(--background-color);\n  min-height: 100vh;\n  overflow: hidden;\n}\n\n.content-wrapper {\n  background-color: var(--background-color);\n  min-height: 100vh;\n  padding: 50px 58px;\n  margin-left: 260px;\n\n  @media (max-width: 1400px) {\n    padding: 32px;\n  }\n\n  @media (max-width: 1200px) {\n    margin-left: 56px;\n  }\n\n  @media (max-width: 768px) {\n    margin-left: 0;\n    padding: 24px;\n  }\n\n  @media (max-width: 576px) {\n    margin-left: 0;\n    padding: 16px;\n  }\n}\n\n// content\n.content-area {\n  & > section {\n    margin-bottom: 16px;\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
